import { createContext, useContext } from 'react';

export const UIContext = createContext({ setInfo: () => {}, lenis: { current: null } });

export const useUI = () => useContext(UIContext);
